import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
import api from '../api';
import router from '../router';

import _ from 'lodash';

import modules from './modules';

var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
    modules,
    getters: {
        token: state => state.token,
        user: state => state.user,
    },
    state: {
        token: null,
        user: {},
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER(state, user) {
            state.user = user;
        },
    },
    actions: {
        successMessage({ commit }, message) {
            Vue.toasted.show(message, {
                duration: 3000,
                className: 'vue-toasted-custom',
            });
        },
        errorMessage({ commit }, message) {
            Vue.toasted.show(message, {
                duration: 3000,
                className: 'vue-toasted-custom--error',
            });
        },
        login({ commit, dispatch }, { code, password }) {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.post('/admin-sessions', {
                        code,
                        password,
                    });

                    const { data } = response;
                    if (data.logged) {
                        commit('SET_TOKEN', response.headers.token);
                        commit('SET_USER', {
                            mode: _.get(data, 'view'),
                            ..._.get(data, 'user'),
                        });
                        resolve({ logged: true, view: _.get(data, 'view') });
                    } else {
                        resolve({});
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
        logout({ commit, dispatch }) {
            console.log('logout');
            commit('SET_TOKEN', null);
            router.push({ name: 'Login' });
        },
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key),
            },
        }),
    ],
});
